import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import React, { useEffect, useState } from 'react';
import idcardfrontsideicon from "../images/hid-icons-id-frontside.svg";
import {
    Row, Col, Spinner, Button, Alert, Card, Modal
} from 'react-bootstrap';
import { isMobile } from "react-device-detect";
import config from '../configuration/config.json';
import axios from 'axios';
import { Buffer } from 'buffer';
import imageCompression from 'browser-image-compression';
import mrzzonemodel from "../images/mrzzonemodel.png";
import nfcabouticon from "../images/Vector.png";

import uparrow from "../images/uparrow.png";

function ScanImage() {
    const title = 'goID ID Proofing Portal';
    const navigate = useNavigate();
    const [image, setImage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [cardType, setCardType] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [variant, setVariant] = useState("info");
    const [messageHeader, setMessageHeader] = useState("Error!");
    const [modalShow, setModalShow] = React.useState(false);
    useEffect(() => {
        if (!isMobile) {
            // navigate('/web-webcam');
        }
        let cardType = localStorage.getItem('CardType');
        setCardType(cardType);

        if (localStorage.getItem('AppMode') == null || localStorage.getItem('AppMode') == undefined
            || localStorage.getItem('AppMode') == ""
        ) {
            const appname = new URLSearchParams(window.location.search).get('appname') || "";
            localStorage.setItem('AppMode', appname);
        }


    }, [])

    async function handleChange(e) {
        if (e.target.files && e.target.files[0]) {
            const imageFile = e.target.files[0];
            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1920,
                useWebWorker: true
            }
            let imSize = imageFile.size / 1024 / 1024;
            let compressedFile;

            if (imSize > 1) {
                compressedFile = await imageCompression(imageFile, options);
            }
            else {
                compressedFile = imageFile;
            }

            var FR = new FileReader();
            FR.onload = function (e) {

                var img = new Image();
                img.src = e.target.result;
                setImage(img.src);
                downloadImage(img.src);
            };
            FR.readAsDataURL(compressedFile);
        }
    }
    async function downloadImage(imageSrc) {
        let base64 = imageSrc.replace(/^data:image\/[a-z]+;base64,/, "");
        let image = Buffer.from(base64, "base64");
        doOCR(image);
    }
    async function doOCR(image) {
        try {
            setIsLoading(true);
            let headers = {
                "content-type": "application/cbor",
                'Authorization': "Bearer " + config.idproofing.token
            };
            const response = await axios.request({
                method: 'POST',
                url: config.idproofing.apibaseurl + "idproofing/ocr/scannedimage/" + cardType,
                headers: headers,
                responseType: 'application/json',
                data: image
            });
            
            if (response.status == 201) {
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse);
                let aid = jsonData.applicationId;
                localStorage.setItem('scanResult', apiResponse);
                setIsLoading(false);
                navigate('/idproofing/additionalinfo/' + aid);

            } else {
                setIsLoading(false);
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse)
                setErrorMessage(jsonData.message);
                setShow(true);
            }
        } catch (e) {
            if (e.response != null && e.response.data != null) {
                let jsonData = JSON.parse(e.response.data);
                setErrorMessage(jsonData.message);
            }
            else { 
                setErrorMessage(e.message);
            }
            setVariant("danger");
            setShow(true);
            setIsLoading(false);
        }
    };


    function MyVerticallyCenteredModal(props) {
        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div class="container-fluid   text-center">
                        <div class="row">
                            <div class="col">
                                <img src={mrzzonemodel} alt="" thumbnail style={{ width: 300, height: 250 }}></img>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <img src={uparrow} alt="" thumbnail></img>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col scaninstructiondisplay">
                               <b> Machine Readable Zone (MRZ)</b><br /><br />

                                Ensure the MRZ is clear with no shadows or reflections
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{
                    display: "flex",
                    justifyContent: "center",
                }}>
                    <Button pill variant="outline-secondary" onClick={props.onHide}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }


    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="viewport" content="width=device-width; initial-scale=1.0;" />
            </Helmet>

            <main className="mainbg">

                <div class="container-fluid  text-center">
                    <div class="row">
                        <div class="col bannerdisplay">
                            
                            <div className="headerdiv">
                                <h1 className="headerdisplay">{title}</h1>
                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col scancontentarea">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col">
                                        <div class="scanmrzzonedisplay">
                                            {image === "" ? (
                                                <img src={mrzzonemodel} alt="" class="mrzmodeldisplay" thumbnail style={{ width: 300, height: 250 }}></img>

                                            ) : (
                                                    <img id='scannedImage' alt="" src={image} class="mrzmodeldisplay" thumbnail style={{ width: 300, height: 250 }} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div>
                                            <span className="scaninstructiondisplay">Capture the document Machine Readable Zone.</span>
                                            &nbsp;<img src={nfcabouticon} onClick={() => setModalShow(true)} alt=""></img>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div><br /><br />
                                            {image != "" ? (
                                                <Button className="btn btn-primary btn-lg"
                                                    disabled={isLoading}
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setImage("");
                                                    }}
                                                >
                                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isLoading} />
                                                    <span className="px-2">Retake Image</span>
                                                </Button>
                                            ) : (

                                                <>{<label htmlFor={'file'} className="btn btn-primary btn-lg">
                                                    <span className="px-2">Open Camera</span>
                                                    <input type='file' id={'file'} style={{ display: 'none' }} onChange={handleChange} accept="image/*" capture />
                                                </label>}</>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <MyVerticallyCenteredModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                />
                </main>
           
            <Alert show={show} variant={variant} onClose={() => setShow(false)} dismissible>
                <Alert.Heading>{messageHeader}</Alert.Heading>
                <p>
                    {errorMessage}.
                </p>
            </Alert>
        </>
    );
}

export default ScanImage;
